export default __webpack_public_path__ + "static/media/bitd.9e1d3006.png";